// Detect environment
// const isLocalhost =
//   window.location.hostname === "localhost"

// API Base URL
export const VITE_API_BASE_URL = 
  // ? "http://localhost:4001/"
   "https://saaflo.com/api";

// Image Base URL (optional)
export const IMAGE_BASE_URL = 
// isLocalhost
  // ? "http://localhost:4001/uploads/"
  // :
   "https://saaflo.com/uploads/";